{
  "about.blocks": "Moderētie serveri",
  "about.contact": "Kontakts:",
  "about.default_locale": "Noklusējums",
  "about.disclaimer": "Mastodon ir brīva, atvērtā pirmkoda programmatūra un Mastodon GmbH prečzīme.",
  "about.domain_blocks.no_reason_available": "Iemesls nav norādīts",
  "about.domain_blocks.preamble": "Mastodon parasti ļauj apskatīt saturu un mijiedarboties ar lietotājiem no jebkura cita fediversa servera. Šie ir izņēmumi, kas veikti tieši šajā serverī.",
  "about.domain_blocks.silenced.explanation": "Parasti tu neredzēsi profilus un saturu no šī servera, ja vien tu nepārprotami izvēlēsies to pārskatīt vai sekot.",
  "about.domain_blocks.silenced.title": "Ierobežotie",
  "about.domain_blocks.suspended.explanation": "Nekādi dati no šī servera netiks apstrādāti, uzglabāti vai apmainīti, padarot neiespējamu jebkādu mijiedarbību vai saziņu ar šī servera lietotājiem.",
  "about.domain_blocks.suspended.title": "Apturētie",
  "about.language_label": "Valoda",
  "about.not_available": "Šī informācija nav padarīta pieejama šajā serverī.",
  "about.powered_by": "Decentralizētu sabiedrisko tīklu darbina {mastodon}",
  "about.rules": "Servera noteikumi",
  "account.account_note_header": "Personīga piezīme",
  "account.activity": "Darbības",
  "account.add_note": "Pievienot personīgu piezīmi",
  "account.add_or_remove_from_list": "Pievienot vai Noņemt no sarakstiem",
  "account.badges.admin": "Pārvaldītājs",
  "account.badges.blocked": "Liegts",
  "account.badges.bot": "Automatizēts",
  "account.badges.domain_blocked": "Liegts domēns",
  "account.badges.group": "Grupa",
  "account.badges.muted": "Apklusināts",
  "account.badges.muted_until": "Apklusināts līdz {until}",
  "account.block": "Bloķēt @{name}",
  "account.block_domain": "Bloķēt domēnu {domain}",
  "account.block_short": "Bloķēt",
  "account.blocked": "Bloķēts",
  "account.cancel_follow_request": "Atsaukt sekošanas pieprasījumu",
  "account.copy": "Ievietot saiti uz profilu starpliktuvē",
  "account.direct": "Pieminēt @{name} privāti",
  "account.disable_notifications": "Pārtraukt man paziņot, kad @{name} izveido ierakstu",
  "account.edit_note": "Labot personīgu piezīmi",
  "account.edit_profile": "Labot profilu",
  "account.edit_profile_short": "Labot",
  "account.enable_notifications": "Paziņot man, kad @{name} izveido ierakstu",
  "account.endorse": "Izcelts profilā",
  "account.familiar_followers_many": "Kam seko {name1}, {name2}, un {othersCount, plural, zero {pārējie # jums pazīstami} one {vēl viens jums pazīstams} other {pārējie # jums pazīstami}}",
  "account.familiar_followers_one": "Kam seko {name1}",
  "account.familiar_followers_two": "Kam seko {name1} un {name2}",
  "account.featured": "Izcelts",
  "account.featured.accounts": "Profili",
  "account.featured.collections": "Krājumi",
  "account.featured.new_collection": "Jauns krājums",
  "account.field_overflow": "Rādīt visu saturu",
  "account.filters.all": "Visas darbības",
  "account.filters.boosts_toggle": "Rādīt pastiprinātos ierakstus",
  "account.filters.posts_boosts": "Ieraksti un pastiprinātie ieraksti",
  "account.filters.posts_only": "Ieraksti",
  "account.filters.posts_replies": "Ieraksti un atbildes",
  "account.filters.replies_toggle": "Rādīt atbildes",
  "account.follow": "Sekot",
  "account.follow_back": "Sekot atpakaļ",
  "account.follow_back_short": "Sekot atpakaļ",
  "account.follow_request": "Pieprasīt sekot",
  "account.follow_request_cancel": "Atcelt pieprasījumu",
  "account.follow_request_cancel_short": "Atcelt",
  "account.follow_request_short": "Pieprasīt",
  "account.followers": "Sekotāji",
  "account.followers.empty": "Šim lietotājam vēl nav sekotāju.",
  "account.followers_counter": "{count, plural, zero {{count} sekotāju} one {{count} sekotājs} other {{count} sekotāji}}",
  "account.followers_you_know_counter": "{counter} jūs pazīstiet",
  "account.following": "Seko",
  "account.following_counter": "{count, plural, one {seko {counter}} other {seko {counter}}}",
  "account.follows.empty": "Šis lietotājs pagaidām nevienam neseko.",
  "account.follows_you": "Seko Tev",
  "account.go_to_profile": "Doties uz profilu",
  "account.hide_reblogs": "Paslēpt @{name} pastiprinātos ierakstus",
  "account.in_memoriam": "Piemiņai.",
  "account.join_modal.day": "Diena",
  "account.join_modal.me": "Tu pievienojies {server}",
  "account.join_modal.me_today": "Šī ir Tava pirmā diena {server}.",
  "account.join_modal.other": "{name} pievienojās {server}",
  "account.join_modal.other_today": "Šī ir {name} pirmā diena {server}.",
  "account.joined_short": "Pievienojās",
  "account.languages": "Mainīt abonētās valodas",
  "account.link_verified_on": "Šīs saites piederība tika pārbaudīta {date}",
  "account.locked_info": "Šī konta privātuma stāvoklis ir iestatīts kā slēgts. Īpašnieks izvērtē, kurš viņam drīkst sekot.",
  "account.media": "Multivide",
  "account.mention": "Pieminēt @{name}",
  "account.menu.add_to_list": "Pievienot sarakstam…",
  "account.menu.block": "Liegt kontu",
  "account.menu.block_domain": "Liegt {domain}",
  "account.menu.copy": "Kopēt saiti",
  "account.menu.mute": "Apklusināt kontu",
  "account.menu.note.description": "Redzams tikai Tev",
  "account.menu.open_original_page": "Apskatīt {domain}",
  "account.menu.remove_follower": "Noņemt sekotāju",
  "account.menu.report": "Ziņot par kontu",
  "account.menu.share": "Kopīgot…",
  "account.menu.show_reblogs": "Laika joslā rādīt pastiprinātos ierakstus",
  "account.menu.unblock": "Atcelt konta liegumu",
  "account.menu.unblock_domain": "Atcelt {domain} liegumu",
  "account.menu.unmute": "Atcelt konta apklusināšanu",
  "account.moved_to": "{name} norādīja, ka viņu jaunais konts tagad ir:",
  "account.mute": "Apklusināt @{name}",
  "account.mute_notifications_short": "Apklusināt paziņojumus",
  "account.mute_short": "Apklusināt",
  "account.muted": "Apklusināts",
  "account.mutual": "Jūs sekojat viens otram",
  "account.name_info": "Ko tas nozīmē?",
  "account.no_bio": "Apraksts nav sniegts.",
  "account.node_modal.save": "Saglabāt",
  "account.note.edit_button": "Labot",
  "account.open_original_page": "Atvērt pirmavota lapu",
  "account.posts": "Ieraksti",
  "account.remove_from_followers": "Dzēst sekotāju {name}",
  "account.report": "Ziņot par @{name}",
  "account.requested_follow": "{name} nosūtīja Tev sekošanas pieprasījumu",
  "account.share": "Dalīties ar @{name} profilu",
  "account.show_reblogs": "Parādīt @{name} pastiprinātos ierakstus",
  "account.statuses_counter": "{count, plural, zero {{counter} ierakstu} one {{counter} ieraksts} other {{counter} ieraksti}}",
  "account.unblock": "Atcelt liegšanu @{name}",
  "account.unblock_domain": "Atcelt domēna {domain} liegšanu",
  "account.unblock_domain_short": "Atcelt liegšanu",
  "account.unblock_short": "Atcelt liegšanu",
  "account.unendorse": "Neizcelt profilā",
  "account.unfollow": "Pārstāt sekot",
  "account.unmute": "Noņemt apklusinājumu @{name}",
  "account.unmute_notifications_short": "Atcelet paziņojumu apklusināšanu",
  "account.unmute_short": "Noņemt apklusinājumu",
  "account_edit.bio.edit_label": "Labot biogrāfiju",
  "account_edit.bio.title": "Biogrāfija",
  "account_edit.bio_modal.add_title": "Pievienot biogrāfiju",
  "account_edit.bio_modal.edit_title": "Labot biogrāfiju",
  "account_edit.column_button": "Darīts",
  "account_edit.column_title": "Labot profilu",
  "account_edit.custom_fields.add_label": "Pievienot lauku",
  "account_edit.custom_fields.edit_label": "Labot lauku",
  "account_edit.field_actions.delete": "Dzēst lauku",
  "account_edit.field_actions.edit": "Labot lauku",
  "account_edit.field_delete_modal.delete_button": "Dzēst",
  "account_edit.field_edit_modal.discard_confirm": "Atmest",
  "account_edit.image_delete_modal.delete_button": "Dzēst",
  "account_edit.image_delete_modal.title": "Dzēst attēlu?",
  "account_edit.image_edit.add_button": "Pievienot attēlu",
  "account_edit.image_edit.remove_button": "Noņemt attēlu",
  "account_edit.save": "Saglabāt",
  "account_edit.upload_modal.back": "Atpakaļ",
  "account_edit.upload_modal.done": "Gatavs",
  "account_edit.upload_modal.step_upload.button": "Pārlūkot failus",
  "account_edit.upload_modal.title_add.avatar": "Pievienot profila fotoattēlu",
  "account_edit.upload_modal.title_add.header": "Pievienot titullapas fotoattēlu",
  "account_edit.upload_modal.title_replace.avatar": "Nomainīt profila fotoattēlu",
  "account_edit.upload_modal.title_replace.header": "Nomainīt titullapas fotoattēlu",
  "account_edit.verified_modal.invisible_link.summary": "Kā saiti padarīt neredzamu?",
  "account_edit_tags.suggestions": "Ieteikumi:",
  "admin.dashboard.daily_retention": "Lietotāju saglabāšanas rādītājs dienā pēc reģistrēšanās",
  "admin.dashboard.monthly_retention": "Lietotāju saglabāšanas rādītājs mēnesī pēc reģistrēšanās",
  "admin.dashboard.retention.average": "Vidēji",
  "admin.dashboard.retention.cohort": "Reģistrēšanās mēnesis",
  "admin.dashboard.retention.cohort_size": "Jauni lietotāji",
  "admin.impact_report.instance_accounts": "Kontu profili tiks dzēsti",
  "admin.impact_report.instance_followers": "Mūsu lietotāji zaudētu sekotājus",
  "admin.impact_report.instance_follows": "Viņu lietotāji zaudētu sekotājus",
  "admin.impact_report.title": "Ietekmes kopsavilkums",
  "alert.rate_limited.message": "Lūdzu, mēģini vēlreiz pēc {retry_time, time, medium}.",
  "alert.rate_limited.title": "Biežums ierobežots",
  "alert.unexpected.message": "Atgadījās neparedzēta kļūda.",
  "alert.unexpected.title": "Ak vai!",
  "alt_text_badge.title": "Alt teksts",
  "alt_text_modal.add_alt_text": "Pievienot aprakstošo tekstu",
  "alt_text_modal.add_text_from_image": "Pievienot tekstu no attēla",
  "alt_text_modal.cancel": "Atcelt",
  "alt_text_modal.change_thumbnail": "Nomainīt sīktēlu",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Aprakstīt šo cilvēkiem ar dzirdes traucējumiem…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Aprakstīt šo cilvēkiem ar redzes traucējumiem…",
  "alt_text_modal.done": "Gatavs",
  "announcement.announcement": "Paziņojums",
  "annual_report.shared_page.donate": "Ziedot",
  "annual_report.summary.archetype.title_public": "Lietotāja \"{name}\" arhetips",
  "annual_report.summary.archetype.title_self": "Tavs arhetips",
  "annual_report.summary.close": "Aizvērt",
  "annual_report.summary.copy_link": "Kopēt saiti",
  "annual_report.summary.most_used_app.most_used_app": "visizmantotākā lietotne",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "visizmantotākais tēmturis",
  "annual_report.summary.new_posts.new_posts": "jauni ieraksti",
  "annual_report.summary.percentile.text": "<topLabel>Tas ievieto Tevi virsējos</topLabel><percentage></percentage><bottomLabel>no {domain} lietotājiem.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Mēs neteiksim Bērnijam.",
  "attachments_list.unprocessed": "(neapstrādāti)",
  "audio.hide": "Slēpt audio",
  "block_modal.remote_users_caveat": "Mēs vaicāsim serverim {domain} ņemt vērā Tavu lēmumu. Tomēr atbilstība nav nodrošināta, jo atsevišķi serveri liegšanu var apstrādāt citādi. Publiski ieraksti joprojām var būt redzami lietotājiem, kuri nav pieteikušies.",
  "block_modal.show_less": "Rādīt mazāk",
  "block_modal.show_more": "Rādīt vairāk",
  "block_modal.they_will_know": "Lietotājs varēs redzēt, ka ir liegts.",
  "block_modal.title": "Liegt lietotāju?",
  "boost_modal.combo": "Nospied {combo}, lai nākamreiz šo izlaistu",
  "boost_modal.reblog": "Pastiprināt ierakstu?",
  "boost_modal.undo_reblog": "Atcelt ieraksta pastiprināšanu?",
  "bundle_column_error.copy_stacktrace": "Ievietot kļūdu ziņojumu starpliktuvē",
  "bundle_column_error.error.body": "Pieprasīto lapu nevarēja atveidot. Tas varētu būt saistīts ar kļūdu mūsu kodā, vai tā ir pārlūkprogrammas saderības problēma.",
  "bundle_column_error.error.title": "Ak vai!",
  "bundle_column_error.network.body": "Kļūda lapas ielādēšanas laikā. Tas varētu būt īslaicīgs sarežģījums ar interneta savienojumu vai šo serveri.",
  "bundle_column_error.network.title": "Tīkla kļūda",
  "bundle_column_error.retry": "Mēģināt vēlreiz",
  "bundle_column_error.return": "Atgriezties",
  "bundle_column_error.routing.body": "Pieprasīto lapu nevarēja atrast. Vai esi pārliecināts, ka URL adreses joslā ir pareizs?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Aizvērt",
  "bundle_modal_error.message": "Kaut kas nogāja greizi šī ekrāna ielādēšanas laikā.",
  "bundle_modal_error.retry": "Mēģināt vēlreiz",
  "closed_registrations.other_server_instructions": "Tā kā Mastodon ir decentralizēts, tu vari izveidot kontu citā serverī un joprojām mijiedarboties ar šo.",
  "closed_registrations_modal.description": "Pašlaik nav iespējams izveidot kontu {domain}, bet, lūdzu, ņem vērā, ka Tev nav nepieciešams tieši {domain} konts, lai lietotu Mastodon!",
  "closed_registrations_modal.find_another_server": "Atrast citu serveri",
  "closed_registrations_modal.preamble": "Mastodon ir decentralizēts, tāpēc neatkarīgi no tā, kur Tu izveido savu kontu, varēsi sekot un mijiedarboties ar ikvienu šajā serverī. Tu pat vari to pašizvietot!",
  "closed_registrations_modal.title": "Reģistrēšanās Mastodon",
  "collections.accounts.empty_title": "Šī kolekcija ir tukša",
  "collections.block_collection_owner": "Liegt kontu",
  "collections.collection_description": "Apraksts",
  "collections.collection_language": "Valoda",
  "collections.collection_language_none": "Nav",
  "collections.collection_name": "Nosaukums",
  "collections.collection_topic": "Tēma",
  "collections.continue": "Turpināt",
  "collections.copy_link": "Kopēt saiti",
  "collections.manage_accounts": "Pārvaldīt kontus",
  "collections.remove_account": "Noņemt",
  "collections.suggestions.can_not_add": "Nevar pievienot",
  "collections.visibility_title": "Redzamība",
  "column.about": "Par",
  "column.blocks": "Liegtie lietotāji",
  "column.bookmarks": "Grāmatzīmes",
  "column.community": "Vietējā laika līnija",
  "column.create_list": "Izveidot sarakstu",
  "column.direct": "Privātas pieminēšanas",
  "column.directory": "Pārlūkot profilus",
  "column.domain_blocks": "Liegtie domēni",
  "column.edit_list": "Labot sarakstu",
  "column.favourites": "Izlase",
  "column.firehose": "Tiešraides plūsmas",
  "column.follow_requests": "Sekošanas pieprasījumi",
  "column.home": "Sākums",
  "column.list_members": "Pārvaldīt saraksta dalībniekus",
  "column.lists": "Saraksti",
  "column.mutes": "Apklusinātie lietotāji",
  "column.notifications": "Paziņojumi",
  "column.pins": "Piespraustie ziņojumi",
  "column.public": "Apvienotā laika līnija",
  "column_back_button.label": "Atpakaļ",
  "column_header.hide_settings": "Paslēpt iestatījumus",
  "column_header.moveLeft_settings": "Pārvietot kolonnu pa kreisi",
  "column_header.moveRight_settings": "Pārvietot kolonnu pa labi",
  "column_header.pin": "Piespraust",
  "column_header.show_settings": "Rādīt iestatījumus",
  "column_header.unpin": "Atspraust",
  "column_search.cancel": "Atcelt",
  "combobox.loading": "Ielādē",
  "combobox.open_results": "Atvērt rezultātus",
  "community.column_settings.local_only": "Tikai vietējie",
  "community.column_settings.media_only": "Tikai multivide",
  "community.column_settings.remote_only": "Tikai attālinātie",
  "compose.error.blank_post": "Ieraksts nedrīkst būt tukšs.",
  "compose.language.change": "Mainīt valodu",
  "compose.language.search": "Meklēt valodas...",
  "compose.published.body": "Ieraksts pievienots.",
  "compose.published.open": "Atvērt",
  "compose.saved.body": "Ieraksts saglabāts.",
  "compose_form.direct_message_warning_learn_more": "Uzzināt vairāk",
  "compose_form.encryption_warning": "Mastodon ieraksti nav pilnībā šifrēti. Nedalies ar jebkādu jūtīgu informāciju caur Mastodon!",
  "compose_form.hashtag_warning": "Šis ieraksts netiks uzrādīts nevienā tēmturī, jo tas nav redzams visiem. Tikai visiem redzamos ierakstus var meklēt pēc tēmtura.",
  "compose_form.lock_disclaimer": "Tavs konts nav {locked}. Ikviens var Tev sekot, lai redzētu tikai sekotājiem paredzētos ierakstus.",
  "compose_form.lock_disclaimer.lock": "slēgts",
  "compose_form.placeholder": "Kas Tev padomā?",
  "compose_form.poll.duration": "Aptaujas ilgums",
  "compose_form.poll.multiple": "Vairākas izvēles iespējas",
  "compose_form.poll.option_placeholder": "Izvēle {number}",
  "compose_form.poll.single": "Viena izvēle",
  "compose_form.poll.switch_to_multiple": "Mainīt aptaujas veidu, lai atļautu vairākas izvēles",
  "compose_form.poll.switch_to_single": "Mainīt aptaujas veidu, lai atļautu vienu izvēli",
  "compose_form.poll.type": "Stils",
  "compose_form.publish": "Iesūtīt",
  "compose_form.reply": "Atbildēt",
  "compose_form.save_changes": "Atjaunināt",
  "compose_form.spoiler.marked": "Noņemt satura brīdinājumu",
  "compose_form.spoiler.unmarked": "Pievienot satura brīdinājumu",
  "compose_form.spoiler_placeholder": "Satura brīdinājums (pēc izvēles)",
  "confirmation_modal.cancel": "Atcelt",
  "confirmations.block.confirm": "Liegt",
  "confirmations.delete.confirm": "Dzēst",
  "confirmations.delete.message": "Vai tiešām izdzēst šo ierakstu?",
  "confirmations.delete.title": "Izdzēst ierakstu?",
  "confirmations.delete_collection.confirm": "Dzēst",
  "confirmations.delete_list.confirm": "Dzēst",
  "confirmations.delete_list.message": "Vai tiešām neatgriezeniski izdzēst šo sarakstu?",
  "confirmations.delete_list.title": "Izdzēst sarakstu?",
  "confirmations.discard_draft.confirm": "Atmest un turpināt",
  "confirmations.discard_draft.edit.cancel": "Atgriezties pie labošanas",
  "confirmations.discard_draft.edit.message": "Ja turpināsi, tiks atmestas izmaiņas ierakstā, kuru Tu šobrīd labo.",
  "confirmations.discard_draft.edit.title": "Atmest ieraksta labojumus?",
  "confirmations.discard_draft.post.cancel": "Atsākt melnrakstu",
  "confirmations.discard_draft.post.message": "Turpinot tiks atmests pašreiz sastādītais ieraksts.",
  "confirmations.discard_draft.post.title": "Atmest melnraksta ierakstu?",
  "confirmations.discard_edit_media.confirm": "Atmest",
  "confirmations.discard_edit_media.message": "Ir nesaglabātas izmaiņas informācijas nesēja aprakstā vai priekšskatījumā. Vēlies tās atmest tik un tā?",
  "confirmations.follow_to_list.confirm": "Sekot un pievienot sarakstam",
  "confirmations.follow_to_list.message": "Ir jāseko {name}, lai pievienotu sarakstam.",
  "confirmations.follow_to_list.title": "Sekot lietotājam?",
  "confirmations.logout.confirm": "Atteikties",
  "confirmations.logout.message": "Vai tiešām atteikties?",
  "confirmations.logout.title": "Atteikties?",
  "confirmations.missing_alt_text.confirm": "Pievienot aprakstošo tekstu",
  "confirmations.missing_alt_text.message": "Tavs ieraksts satur informācijas nesējus bez paskaidrojošā teksta. Aprakstu pievienošana palīdz padarīt saturu pieejamāku vairāk cilvēku.",
  "confirmations.missing_alt_text.secondary": "Vienalga iesūtīt",
  "confirmations.missing_alt_text.title": "Pievienot aprakstošo tekstu?",
  "confirmations.mute.confirm": "Apklusināt",
  "confirmations.private_quote_notify.cancel": "Atgriezties pie labošanas",
  "confirmations.private_quote_notify.confirm": "Ievietot ierakstu",
  "confirmations.private_quote_notify.do_not_show_again": "Nerādīt vairāk šo paziņojumu",
  "confirmations.private_quote_notify.title": "Dalīties ar sekotājiem un pieminētajiem lietotājiem?",
  "confirmations.quiet_post_quote_info.got_it": "Sapratu",
  "confirmations.redraft.confirm": "Dzēst un pārrakstīt",
  "confirmations.redraft.message": "Vai tiešām vēlies izdzēst šo ierakstu un veidot jaunu tā uzmetumu? Pievienošana izlasēs un pastiprinājumi tiks zaudēti, un sākotnējā ieraksta atbildes paliks bez saiknes ar to.",
  "confirmations.redraft.title": "Izdzēst un rakstīt ierakstu no jauna?",
  "confirmations.remove_from_followers.confirm": "Dzēst sekotāju",
  "confirmations.remove_from_followers.message": "{name} pārstās sekot jums. Vai tiešām vēlaties turpināt?",
  "confirmations.remove_from_followers.title": "Vai dzēst sekotāju?",
  "confirmations.revoke_quote.confirm": "Noņemt ierakstu",
  "confirmations.revoke_quote.message": "Šo darbību nevar atsaukt.",
  "confirmations.revoke_quote.title": "Noņemt ierakstu?",
  "confirmations.unblock.confirm": "Atcelt liegšanu",
  "confirmations.unblock.title": "Atcelt {name} liegumu?",
  "confirmations.unfollow.confirm": "Pārstāt sekot",
  "confirmations.unfollow.title": "Pārtraukt sekot {name}?",
  "confirmations.withdraw_request.confirm": "Atsaukt pieprasījumu",
  "content_warning.hide": "Paslēpt ierakstu",
  "content_warning.show": "Tomēr rādīt",
  "content_warning.show_more": "Rādīt vairāk",
  "conversation.delete": "Dzēst sarunu",
  "conversation.mark_as_read": "Atzīmēt kā izlasītu",
  "conversation.open": "Skatīt sarunu",
  "conversation.with": "Ar {names}",
  "copy_icon_button.copied": "Ievietots starpliktuvē",
  "copypaste.copied": "Nokopēts",
  "copypaste.copy_to_clipboard": "Ievietot starpliktuvē",
  "directory.federated": "No zināma fediversa",
  "directory.local": "Tikai no {domain}",
  "directory.new_arrivals": "Jaunpienācēji",
  "directory.recently_active": "Nesen izmantojušie",
  "disabled_account_banner.account_settings": "Konta iestatījumi",
  "disabled_account_banner.text": "Tavs konts {disabledAccount} pašlaik ir atspējots.",
  "dismissable_banner.community_timeline": "Šie ir jaunākie publiskie ieraksti no cilvēkiem, kuru konti ir mitināti {domain}.",
  "dismissable_banner.dismiss": "Atcelt",
  "dismissable_banner.public_timeline": "Šie ir jaunākie Fediverse lietotāju publiskie ieraksti, kuriem {domain} seko cilvēki.",
  "domain_block_modal.block": "Liegt serveri",
  "domain_block_modal.block_account_instead": "Tā vietā liegt @{name}",
  "domain_block_modal.they_cant_follow": "Neviens no šī servera nevarēs Tev sekot.",
  "domain_block_modal.they_wont_know": "Viņi nezinās, ka tikuši liegti.",
  "domain_block_modal.title": "Liegt domēnu?",
  "domain_block_modal.you_will_lose_num_followers": "Tu zaudēsi {followersCount, plural, one {{followersCountDisplay} sekotāju} other {{followersCountDisplay} sekotājus}} un {followingCount, plural, one {{followingCountDisplay} sekojamo} other {{followingCountDisplay} sekojamos}}.",
  "domain_block_modal.you_will_lose_relationships": "Tu zaudēsi visus sekotājus un sekojamos no šī servera.",
  "dropdown.empty": "Atlasīt iespēju",
  "embed.instructions": "Iekļauj šo ierakstu savā tīmekļvietnē, ievietojot zemāk redzamo kodu starpliktuvē!",
  "embed.preview": "Tas izskatīsies šādi:",
  "emoji_button.activity": "Aktivitāte",
  "emoji_button.clear": "Notīrīt",
  "emoji_button.custom": "Pielāgots",
  "emoji_button.flags": "Karogi",
  "emoji_button.food": "Ēdieni un dzērieni",
  "emoji_button.label": "Ievietot emocijzīmi",
  "emoji_button.nature": "Daba",
  "emoji_button.not_found": "Neviena atbilstoša emocijzīme netika atrasta",
  "emoji_button.objects": "Objekti",
  "emoji_button.people": "Cilvēki",
  "emoji_button.recent": "Biežāk lietotie",
  "emoji_button.search": "Meklēt...",
  "emoji_button.search_results": "Meklēšanas rezultāti",
  "emoji_button.symbols": "Simboli",
  "emoji_button.travel": "Ceļošana un vietas",
  "empty_column.account_hides_collections": "Šis lietotājs ir izvēlējies nedarīt šo informāciju pieejamu",
  "empty_column.account_suspended": "Konta darbība ir apturēta",
  "empty_column.account_timeline": "Šeit nav ierakstu.",
  "empty_column.account_unavailable": "Profils nav pieejams",
  "empty_column.blocks": "Pagaidām Tu neesi liedzis nevienu lietotāju.",
  "empty_column.bookmarked_statuses": "Pašlaik Tev nav neviena grāmatzīmēs pievienota ieraksta. Kad tādu pievienosi, tas parādīsies šeit.",
  "empty_column.community": "Vietējā laika līnija ir tukša. Uzraksti kaut ko publiski, lai iekustinātu visu!",
  "empty_column.direct": "Tev vēl nav privātu pieminēšanu. Kad Tu nosūtīsi vai saņemsi kādu, tā pārādīsies šeit.",
  "empty_column.domain_blocks": "Vēl nav neviena liegta domēna.",
  "empty_column.explore_statuses": "Pašlaik nav nekā aktuāla. Ieskaties šeit vēlāk!",
  "empty_column.favourited_statuses": "Tev vēl nav izlasei pievienotu ierakstu. Kad pievienosi kādu, tas tiks parādīts šeit.",
  "empty_column.favourites": "Šo ierakstu vēl neviens nav pievienojis izlasei. Kad kāds to izdarīs, tas parādīsies šeit.",
  "empty_column.follow_requests": "Šobrīd Tev nav sekošanas pieprasījumu. Kad saņemsi kādu, tas parādīsies šeit.",
  "empty_column.followed_tags": "Tu vēl neseko nevienam tēmturim. Kad to izdarīsi, tie tiks parādīti šeit.",
  "empty_column.hashtag": "Ar šo tēmturi nekas nav atrodams.",
  "empty_column.home": "Tava mājas laika līnija ir tukša. Seko vairāk cilvēkiem, lai to piepildītu!",
  "empty_column.list": "Pagaidām šajā sarakstā nekā nav. Kad šī saraksta dalībnieki ievietos jaunus ierakstus, tie parādīsies šeit.",
  "empty_column.mutes": "Neviens lietotājs vēl nav apklusināts.",
  "empty_column.notifications": "Tev vēl nav paziņojumu. Kad citi cilvēki ar Tevi mijiedarbosies, Tu to redzēsi šeit.",
  "empty_column.public": "Šeit nekā nav. Ieraksti kaut ko publiski vai seko lietotājiem no citiem serveriem, lai iegūtu saturu",
  "error.unexpected_crash.explanation": "Koda kļūdas vai pārlūkprogrammas saderības problēmas dēļ šo lapu nevarēja parādīt pareizi.",
  "error.unexpected_crash.explanation_addons": "Šo lapu nevarēja parādīt pareizi. Šo kļūdu, iespējams, izraisīja pārlūkprogrammas papildinājums vai automātiskās tulkošanas rīki.",
  "error.unexpected_crash.next_steps": "Mēģini atsvaidzināt lapu. Ja tas nepalīdz, iespējams, varēsi lietot Mastodon, izmantojot citu pārlūkprogrammu vai lietotni.",
  "error.unexpected_crash.next_steps_addons": "Mēģini tos atspējot un atsvaidzināt lapu. Ja tas nepalīdz, iespējams, varēsi lietot Mastodon, izmantojot citu pārlūkprogrammu vai lietotni.",
  "errors.unexpected_crash.copy_stacktrace": "Kopēt stacktrace uz starpliktuvi",
  "errors.unexpected_crash.report_issue": "Ziņot par problēmu",
  "explore.suggested_follows": "Cilvēki",
  "explore.title": "Populārākie",
  "explore.trending_links": "Jaunumi",
  "explore.trending_statuses": "Ieraksti",
  "explore.trending_tags": "Tēmturi",
  "filter_modal.added.context_mismatch_explanation": "Šī atlases kategorija neattiecas uz kontekstu, kurā esi piekļuvis šim ierakstam. Ja vēlies, lai ieraksts tiktu atlasīts arī šajā kontekstā, Tev būs jālabo atlase.",
  "filter_modal.added.context_mismatch_title": "Konteksta neatbilstība!",
  "filter_modal.added.expired_explanation": "Šai atlases kategorijai ir beidzies derīguma termiņš. Lai to lietotu, Tev būs jāmaina derīguma termiņš.",
  "filter_modal.added.expired_title": "Filtra termiņš beidzies!",
  "filter_modal.added.review_and_configure": "Lai pārskatītu un tālāk konfigurētu šo filtru kategoriju, dodies uz {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filtra iestatījumi",
  "filter_modal.added.settings_link": "iestatījumu lapu",
  "filter_modal.added.short_explanation": "Šis ieraksts tika pievienots šai atlasīšanas kategorijai: {title}.",
  "filter_modal.added.title": "Filtrs pievienots!",
  "filter_modal.select_filter.context_mismatch": "neattiecas uz šo kontekstu",
  "filter_modal.select_filter.expired": "beidzies",
  "filter_modal.select_filter.prompt_new": "Jauna kategorija: {name}",
  "filter_modal.select_filter.search": "Meklēt vai izveidot",
  "filter_modal.select_filter.subtitle": "Izmanto esošu kategoriju vai izveido jaunu",
  "filter_modal.select_filter.title": "Atlasīt šo ierakstu",
  "filter_modal.title.status": "Atlasīt ziņu",
  "filter_warning.matches_filter": "Atbilst atlasītājam “<span>{title}</span>”",
  "filtered_notifications_banner.title": "Filtrētie paziņojumi",
  "firehose.all": "Visi",
  "firehose.local": "Šis serveris",
  "firehose.remote": "Citi serveri",
  "follow_request.authorize": "Pilnvarot",
  "follow_request.reject": "Noraidīt",
  "follow_requests.unlocked_explanation": "Lai gan Tavs konts nav slēgts, {domain} darbinieki iedomājās, ka Tu varētu vēlēties pašrocīgi pārskatīt sekošanas pieprasījumus no šiem kontiem.",
  "follow_suggestions.curated_suggestion": "Darbinieku izvēle",
  "follow_suggestions.dismiss": "Vairs nerādīt",
  "follow_suggestions.friends_of_friends_longer": "Populārs to cilvēku vidū, kuriem tu seko",
  "follow_suggestions.personalized_suggestion": "Pielāgots ieteikums",
  "follow_suggestions.popular_suggestion": "Populārs ieteikums",
  "follow_suggestions.popular_suggestion_longer": "Populārs {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Līdzīgi profieliem, kuriem nesen sāki sekot",
  "follow_suggestions.view_all": "Skatīt visu",
  "follow_suggestions.who_to_follow": "Kam sekot",
  "followed_tags": "Sekojamie tēmturi",
  "followers.hide_other_followers": "Šis lietotājs izvēlējās nepadarīt savus citus sekotājus redzamus",
  "footer.about": "Par",
  "footer.about_this_server": "Par",
  "footer.directory": "Profilu direktorija",
  "footer.get_app": "Iegūt lietotni",
  "footer.keyboard_shortcuts": "Īsinājumtaustiņi",
  "footer.privacy_policy": "Privātuma politika",
  "footer.source_code": "Skatīt pirmkodu",
  "footer.status": "Stāvoklis",
  "footer.terms_of_service": "Pakalpojuma noteikumi",
  "getting_started.heading": "Darba sākšana",
  "hashtag.admin_moderation": "Atvērt #{name} satura pārraudzības saskarni",
  "hashtag.browse": "Pārlūkot #{hashtag} ierakstus",
  "hashtag.browse_from_account": "Pārlūkot @{name} #{hashtag} ierakstus",
  "hashtag.column_header.tag_mode.all": "un {additional}",
  "hashtag.column_header.tag_mode.any": "vai {additional}",
  "hashtag.column_header.tag_mode.none": "bez {additional}",
  "hashtag.column_settings.select.no_options_message": "Ieteikumi netika atrasti",
  "hashtag.column_settings.select.placeholder": "Ievadīt tēmturus…",
  "hashtag.column_settings.tag_mode.all": "Visi no šiem",
  "hashtag.column_settings.tag_mode.any": "Kāds no šiem",
  "hashtag.column_settings.tag_mode.none": "Neviens no šiem",
  "hashtag.column_settings.tag_toggle": "Iekļaut šajā kolonnā papildu birkas",
  "hashtag.counter_by_accounts": "{count, plural, zero{{counter} dalībnieku} one {{counter} dalībnieks} other {{counter} dalībnieki}}",
  "hashtag.counter_by_uses": "{count, plural, zero {{counter} ierakstu} one {{counter} ieraksts} other {{counter} ieraksti}}",
  "hashtag.counter_by_uses_today": "{count, plural, zero {{counter} ierakstu} one {{counter} ieraksts} other {{counter} ieraksti}} šodien",
  "hashtag.feature": "Attēlot profilā",
  "hashtag.follow": "Sekot tēmturim",
  "hashtag.mute": "Apklusināt #{hashtag}",
  "hashtag.unfeature": "Neattēlot profilā",
  "hashtag.unfollow": "Pārstāt sekot tēmturim",
  "hashtags.and_other": "… un {count, plural, other {vēl #}}",
  "hints.profiles.see_more_followers": "Skatīt vairāk sekotāju {domain}",
  "hints.profiles.see_more_follows": "Skatīt vairāk sekojumu {domain}",
  "hints.profiles.see_more_posts": "Skatīt vairāk ierakstu {domain}",
  "home.column_settings.show_quotes": "Rādīt citātus",
  "home.column_settings.show_reblogs": "Rādīt pastiprinātos ierakstus",
  "home.column_settings.show_replies": "Rādīt atbildes",
  "home.hide_announcements": "Slēpt paziņojumus",
  "home.pending_critical_update.body": "Lūgums pēc iespējas drīzāk atjaunināt savu Mastodon serveri.",
  "home.pending_critical_update.link": "Skatīt jauninājumus",
  "home.pending_critical_update.title": "Ir pieejams būtisks drošības atjauninājums.",
  "home.show_announcements": "Rādīt paziņojumus",
  "ignore_notifications_modal.ignore": "Neņemt vērā paziņojumus",
  "ignore_notifications_modal.limited_accounts_title": "Neņemt vērā paziņojumus no moderētiem kontiem?",
  "ignore_notifications_modal.new_accounts_title": "Neņemt vērā paziņojumus no jauniem kontiem?",
  "ignore_notifications_modal.not_followers_title": "Neņemt vērā paziņojumus no cilvēkiem, kas tev neseko?",
  "ignore_notifications_modal.not_following_title": "Neņemt vērā paziņojumus no cilvēkiem, kuriem neseko?",
  "info_button.label": "Palīdzība",
  "interaction_modal.go": "Aiziet",
  "interaction_modal.no_account_yet": "Vēl nav konta?",
  "interaction_modal.on_another_server": "Citā serverī",
  "interaction_modal.on_this_server": "Šajā serverī",
  "interaction_modal.username_prompt": "Piem., {example}",
  "intervals.full.days": "{number, plural, one {# diena} other {# dienas}}",
  "intervals.full.hours": "{number, plural, one {# stunda} other {# stundas}}",
  "intervals.full.minutes": "{number, plural, one {# minūte} other {# minūtes}}",
  "keyboard_shortcuts.back": "Pāriet atpakaļ",
  "keyboard_shortcuts.blocked": "Atvērt liegto lietotāju sarakstu",
  "keyboard_shortcuts.boost": "Pastiprināt ierakstu",
  "keyboard_shortcuts.column": "Fokusēt kolonnu",
  "keyboard_shortcuts.compose": "Fokusēt veidojamā teksta lauku",
  "keyboard_shortcuts.description": "Apraksts",
  "keyboard_shortcuts.down": "Pārvietoties lejup sarakstā",
  "keyboard_shortcuts.enter": "Atvērt ierakstu",
  "keyboard_shortcuts.favourite": "Pievienot ierakstu izlasei",
  "keyboard_shortcuts.favourites": "Atvērt izlases sarakstu",
  "keyboard_shortcuts.federated": "Atvērt apvienoto laika līniju",
  "keyboard_shortcuts.heading": "Īsinājumtaustiņi",
  "keyboard_shortcuts.home": "Atvērt mājas laika līniju",
  "keyboard_shortcuts.hotkey": "Ātrais taustiņš",
  "keyboard_shortcuts.legend": "Parādīt šo leģendu",
  "keyboard_shortcuts.local": "Atvērt vietējo laika līniju",
  "keyboard_shortcuts.mention": "Pieminēt autoru",
  "keyboard_shortcuts.muted": "Atvērt noklusināto lietotāju sarakstu",
  "keyboard_shortcuts.my_profile": "Atvērt savu profilu",
  "keyboard_shortcuts.notifications": "Atvērt paziņojumu kolonnu",
  "keyboard_shortcuts.open_media": "Atvērt multividi",
  "keyboard_shortcuts.pinned": "Atvērt piesprausto ierakstu sarakstu",
  "keyboard_shortcuts.profile": "Atvērt autora profilu",
  "keyboard_shortcuts.quote": "Citēt ierakstu",
  "keyboard_shortcuts.reply": "Atbildēt",
  "keyboard_shortcuts.requests": "Atvērt sekošanas pieprasījumu sarakstu",
  "keyboard_shortcuts.search": "Fokusēt meklēšanas joslu",
  "keyboard_shortcuts.spoilers": "Rādīt/slēpt satura brīdinājumu lauku",
  "keyboard_shortcuts.start": "Atvērt kolonnu “Darba sākšana”",
  "keyboard_shortcuts.toggle_hidden": "Rādīt/slēpt tekstu aiz satura brīdinājuma",
  "keyboard_shortcuts.toggle_sensitivity": "Rādīt/slēpt multividi",
  "keyboard_shortcuts.toot": "Uzsākt jaunu ierakstu",
  "keyboard_shortcuts.unfocus": "Atfokusēt veidojamā teksta/meklēšanas lauku",
  "keyboard_shortcuts.up": "Pārvietoties augšup sarakstā",
  "learn_more_link.got_it": "Sapratu",
  "learn_more_link.learn_more": "Uzzināt vairāk",
  "lightbox.close": "Aizvērt",
  "lightbox.next": "Tālāk",
  "lightbox.previous": "Iepriekšējais",
  "lightbox.zoom_in": "Tālummainīt līdz patiesajam izmēram",
  "lightbox.zoom_out": "Tālummainīt, lai ietilpinātu",
  "limited_account_hint.action": "Tik un tā rādīt profilu",
  "link_preview.author": "No {name}",
  "link_preview.more_from_author": "Vairāk no {name}",
  "lists.add_member": "Pievienot",
  "lists.add_to_list": "Pievienot sarakstam",
  "lists.add_to_lists": "Pievienot {name} sarakstiem",
  "lists.create": "Izveidot",
  "lists.create_list": "Izveidot sarakstu",
  "lists.delete": "Izdzēst sarakstu",
  "lists.done": "Gatavs",
  "lists.edit": "Labot sarakstu",
  "lists.find_users_to_add": "Atrast lietotājus, kurus pievienot",
  "lists.list_name": "Saraksta nosaukums",
  "lists.remove_member": "Noņemt",
  "lists.replies_policy.followed": "Jebkuram sekotajam lietotājam",
  "lists.replies_policy.list": "Saraksta dalībniekiem",
  "lists.replies_policy.none": "Nevienam",
  "lists.save": "Saglabāt",
  "lists.search": "Meklēt",
  "load_pending": "{count, plural, zero{# jaunu vienumu} one {# jauns vienums} other {# jauni vienumi}}",
  "loading_indicator.label": "Ielādē…",
  "media_gallery.hide": "Paslēpt",
  "moved_to_account_banner.text": "Tavs konts {disabledAccount} pašlaik ir atspējots, jo Tu pārcēlies uz kontu {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Paslēpt paziņojumos",
  "mute_modal.hide_options": "Paslēpt iespējas",
  "mute_modal.show_options": "Parādīt iespējas",
  "mute_modal.title": "Apklusināt lietotāju?",
  "navigation_bar.about": "Par",
  "navigation_bar.account_settings": "Parole un drošība",
  "navigation_bar.administration": "Pārvaldība",
  "navigation_bar.advanced_interface": "Atvērt paplašinātā tīmekļa saskarnē",
  "navigation_bar.automated_deletion": "Automātiska ziņu dzēšana",
  "navigation_bar.blocks": "Liegtie lietotāji",
  "navigation_bar.bookmarks": "Grāmatzīmes",
  "navigation_bar.direct": "Privātas pieminēšanas",
  "navigation_bar.domain_blocks": "Liegtie domēni",
  "navigation_bar.favourites": "Izlase",
  "navigation_bar.filters": "Apklusinātie vārdi",
  "navigation_bar.follow_requests": "Sekošanas pieprasījumi",
  "navigation_bar.followed_tags": "Sekojamie tēmturi",
  "navigation_bar.follows_and_followers": "Seko un sekotāji",
  "navigation_bar.import_export": "Imports un eksports",
  "navigation_bar.lists": "Saraksti",
  "navigation_bar.logout": "Iziet",
  "navigation_bar.moderation": "Satura pārraudzība",
  "navigation_bar.more": "Vairāk",
  "navigation_bar.mutes": "Apklusinātie lietotāji",
  "navigation_bar.opened_in_classic_interface": "Ieraksti, konti un citas noteiktas lapas pēc noklusējuma tiek atvērtas klasiskajā tīmekļa saskarnē.",
  "navigation_bar.preferences": "Iestatījumi",
  "navigation_bar.privacy_and_reach": "Privātums un sasniedzamība",
  "navigation_bar.search": "Meklēt",
  "not_signed_in_indicator.not_signed_in": "Ir jāpiesakās, lai piekļūtu šim resursam.",
  "notification.admin.report": "{name} ziņoja par {target}",
  "notification.admin.report_account": "{name} ziņoja par {count, plural, one {# ierakstu} other {# ierakstiem}} no {target} ar iemeslu: {category}",
  "notification.admin.report_statuses": "{name} ziņoja par {target} ar iemeslu: {category}",
  "notification.admin.sign_up": "{name} pierakstījās",
  "notification.favourite": "{name} pievienoja izlasei Tavu ierakstu",
  "notification.favourite.name_and_others_with_link": "{name} un <a>{count, plural, one {# cits} other {# citi}}</a> pievienoja Tavu ierakstu izlasē",
  "notification.favourite_pm": "{name} pievienoja izlasē Tavu privāto pieminējumu",
  "notification.favourite_pm.name_and_others_with_link": "{name} un <a>{count, plural, one {# cits} other {# citi}}</a> pievienoja Tavu privāto pieminējumu izlasē",
  "notification.follow": "{name} uzsāka Tev sekot",
  "notification.follow_request": "{name} nosūtīja Tev sekošanas pieprasījumu",
  "notification.label.quote": "{name} citēja tavu ierakstu",
  "notification.mentioned_you": "{name} pieminēja tevi",
  "notification.moderation-warning.learn_more": "Uzzināt vairāk",
  "notification.moderation_warning": "Ir saņemts satura pārraudzības brīdinājums",
  "notification.moderation_warning.action_delete_statuses": "Daži no Taviem ierakstiem tika noņemti.",
  "notification.moderation_warning.action_disable": "Tavs konts tika atspējots.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Daži no Taviem ierakstiem tika atzīmēti kā jūtīgi.",
  "notification.moderation_warning.action_none": "Konts ir saņēmis satura pārraudzības brīdinājumu.",
  "notification.moderation_warning.action_sensitive": "Tavi ieraksti turpmāk tiks atzīmēti kā jūtīgi.",
  "notification.moderation_warning.action_silence": "Tavs konts tika ierobežots.",
  "notification.moderation_warning.action_suspend": "Tava konta darbība tika apturēta.",
  "notification.own_poll": "Tava aptauja ir noslēgusies",
  "notification.quoted_update": "{name} laboja tevis citētu ierakstu",
  "notification.reblog": "{name} pastiprināja Tavu ierakstu",
  "notification.relationships_severance_event": "Zaudēti savienojumi ar {name}",
  "notification.relationships_severance_event.learn_more": "Uzzināt vairāk",
  "notification.status": "{name} tikko pievienoja ierakstu",
  "notification.update": "{name} laboja ierakstu",
  "notification_requests.accept": "Pieņemt",
  "notification_requests.dismiss": "Noraidīt",
  "notification_requests.edit_selection": "Labot",
  "notification_requests.exit_selection": "Gatavs",
  "notification_requests.explainer_for_limited_account": "Paziņojumi no šī konta tika atsijāti, jo pārvaldītājs ierobežoja kontu.",
  "notification_requests.explainer_for_limited_remote_account": "Paziņojumi no šī konta tika atsijāti, jo pārvaldītājs ierobežoja kontu vai tā serveri.",
  "notification_requests.notifications_from": "Paziņojumi no {name}",
  "notification_requests.title": "Atlasītie paziņojumi",
  "notification_requests.view": "Skatīt paziņojumus",
  "notifications.clear": "Notīrīt paziņojumus",
  "notifications.clear_confirmation": "Vai tiešām vēlies neatgriezeniski notīrīt visus savus paziņojumus?",
  "notifications.column_settings.admin.report": "Jauni ziņojumi:",
  "notifications.column_settings.admin.sign_up": "Jaunas pierakstīšanās:",
  "notifications.column_settings.alert": "Darbvirsmas paziņojumi",
  "notifications.column_settings.favourite": "Izlase:",
  "notifications.column_settings.filter_bar.advanced": "Attēlot visas kategorijas",
  "notifications.column_settings.filter_bar.category": "Atrās atlasīšanas josla",
  "notifications.column_settings.follow": "Jauni sekotāji:",
  "notifications.column_settings.follow_request": "Jauni sekošanas pieprasījumi:",
  "notifications.column_settings.group": "Grupēt",
  "notifications.column_settings.mention": "Pieminēšanas:",
  "notifications.column_settings.poll": "Aptaujas rezultāti:",
  "notifications.column_settings.push": "Uznirstošie paziņojumi",
  "notifications.column_settings.reblog": "Pastiprinātie ieraksti:",
  "notifications.column_settings.show": "Rādīt kolonnā",
  "notifications.column_settings.sound": "Atskaņot skaņu",
  "notifications.column_settings.status": "Jauni ieraksti:",
  "notifications.column_settings.unread_notifications.category": "Nelasītie paziņojumi",
  "notifications.column_settings.unread_notifications.highlight": "Iezīmēt nelasītos paziņojumus",
  "notifications.column_settings.update": "Labojumi:",
  "notifications.filter.all": "Visi",
  "notifications.filter.boosts": "Pastiprinātie ieraksti",
  "notifications.filter.favourites": "Izlase",
  "notifications.filter.follows": "Seko",
  "notifications.filter.mentions": "Pieminēšanas",
  "notifications.filter.polls": "Aptaujas rezultāti",
  "notifications.filter.statuses": "Jaunumi no cilvēkiem, kuriem tu seko",
  "notifications.grant_permission": "Piešķirt atļauju.",
  "notifications.group": "{count} paziņojumi",
  "notifications.mark_as_read": "Atzīmēt katru paziņojumu kā izlasītu",
  "notifications.permission_denied": "Darbvirsmas paziņojumi nav pieejami, jo iepriekš tika noraidīts pārlūka atļauju pieprasījums",
  "notifications.permission_denied_alert": "Darbvirsmas paziņojumus nevar iespējot, jo pārlūkprogrammai atļauja tika iepriekš atteikta",
  "notifications.permission_required": "Darbvirsmas paziņojumi nav pieejami, jo nav piešķirta nepieciešamā atļauja.",
  "notifications.policy.accept": "Pieņemt",
  "notifications.policy.drop": "Ignorēt",
  "notifications.policy.filter_limited_accounts_hint": "Servera satura pārraudzītāju ierobežots",
  "notifications.policy.filter_new_accounts_title": "Jauni konti",
  "notifications.policy.filter_not_followers_title": "Cilvēki, kuri Tev neseko",
  "notifications.policy.filter_not_following_hint": "Līdz tos pašrocīgi apstiprināsi",
  "notifications.policy.filter_not_following_title": "Cilvēki, kuriem Tu neseko",
  "notifications_permission_banner.enable": "Iespējot darbvirsmas paziņojumus",
  "notifications_permission_banner.how_to_control": "Lai saņemtu paziņojumus, kad Mastodon nav atvērts, jāiespējo darbvirsmas paziņojumi. Var pārvaldīt, tieši kāda veida mijiedarbības rada darbvirsmas paziņojumus, izmantojot augstāk redzamo pogu {icon}, tiklīdz tie būs iespējoti.",
  "notifications_permission_banner.title": "Nekad nepalaid neko garām",
  "onboarding.follows.back": "Atpakaļ",
  "onboarding.follows.empty": "Diemžēl pašlaik nevar parādīt rezultātus. Vari mēģināt izmantot meklēšanu vai pārlūkot izpētes lapu, lai atrastu cilvēkus, kuriem sekot, vai vēlāk mēģināt vēlreiz.",
  "onboarding.follows.search": "Meklēt",
  "onboarding.profile.discoverable": "Padarīt manu profilu atklājamu",
  "onboarding.profile.display_name": "Attēlojamais vārds",
  "onboarding.profile.display_name_hint": "Tavs pilnais vārds vai Tavs joku vārds…",
  "onboarding.profile.note": "Apraksts",
  "onboarding.profile.note_hint": "Tu vari @pieminēt citus cilvēkus vai #tēmturus…",
  "onboarding.profile.title": "Profila iestatīšana",
  "onboarding.profile.upload_avatar": "Augšupielādēt profila attēlu",
  "onboarding.profile.upload_header": "Augšupielādēt profila galveni",
  "password_confirmation.exceeds_maxlength": "Paroles apstiprināšana pārsniedz maksimālo paroles garumu",
  "password_confirmation.mismatching": "Paroles apstiprinājums neatbilst",
  "picture_in_picture.restore": "Novietot atpakaļ",
  "poll.closed": "Pabeigta",
  "poll.refresh": "Atsvaidzināt",
  "poll.reveal": "Skatīt rezultātus",
  "poll.total_people": "{count, plural, zero {# cilvēku} one {# cilvēks} other {# cilvēki}}",
  "poll.total_votes": "{count, plural, zero {# balsojumu} one {# balsojums} other {# balsojumi}}",
  "poll.vote": "Balsot",
  "poll.voted": "Tu balsoji par šo atbildi",
  "poll.votes": "{votes, plural, zero {# balsu} one {# balss} other {# balsis}}",
  "poll_button.add_poll": "Pievienot aptauju",
  "poll_button.remove_poll": "Noņemt aptauju",
  "privacy.change": "Mainīt ieraksta privātumu",
  "privacy.direct.long": "Visi ierakstā pieminētie",
  "privacy.private.long": "Tikai Tavi sekotāji",
  "privacy.private.short": "Sekotāji",
  "privacy.public.long": "Jebkurš Mastodon platformā un ārpus tās",
  "privacy.public.short": "Publisks",
  "privacy.quote.disabled": "{visibility}, aizliegta citēšana",
  "privacy.quote.limited": "{visibility}, ierobežota citēšana",
  "privacy.unlisted.additional": "Šis uzvedas tieši kā publisks, izņemot to, ka ieraksts neparādīsies tiešraides barotnēs vai tēmturos, izpētē vai Mastodon meklēšanā, pat ja esi to norādījis visa konta ietvaros.",
  "privacy.unlisted.long": "Netiks rādīts Mastodon meklēšanas rezultātos, populārākajos, un publiskajās laikjoslās",
  "privacy.unlisted.short": "Klusi publisks",
  "privacy_policy.last_updated": "Pēdējo reizi atjaunināta {date}",
  "privacy_policy.title": "Privātuma politika",
  "recommended": "Ieteicams",
  "refresh": "Atsvaidzināt",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "Pirms {number, plural, one {# dienas} other {# dienām}}",
  "relative_time.full.hours": "Pirms {number, plural, one {# stundas} other {# stundām}}",
  "relative_time.full.just_now": "tikko",
  "relative_time.full.minutes": "Pirms {number, plural, one {# minūtes} other {# minūtēm}}",
  "relative_time.full.seconds": "Pirms {number, plural, one {# sekundes} other {# sekundēm}}",
  "relative_time.hours": "{number}st",
  "relative_time.just_now": "tagad",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "šodien",
  "remove_quote_hint.button_label": "Sapratu",
  "reply_indicator.attachments": "{count, plural, zero{# pielikumu} one {# pielikums} other {# pielikumi}}",
  "reply_indicator.cancel": "Atcelt",
  "reply_indicator.poll": "Aptauja",
  "report.block": "Liegt",
  "report.block_explanation": "Tu neredzēsi viņu ierakstus. Viņi nevarēs redzēt Tavus ierakstus vai sekot Tev. Viņi varēs saprast, ka ir liegti.",
  "report.categories.legal": "Tiesisks",
  "report.categories.other": "Citi",
  "report.categories.spam": "Mēstule",
  "report.categories.violation": "Saturs pārkāpj vienu vai vairākus servera noteikumus",
  "report.category.subtitle": "Izvēlieties labāko atbilstību",
  "report.close": "Darīts",
  "report.comment.title": "Vai, tavuprāt, mums vēl būtu kas jāzina?",
  "report.forward": "Pārsūtīt {target}",
  "report.forward_hint": "Konts ir no cita servera. Vai nosūtīt anonimizētu ziņojuma kopiju arī tur?",
  "report.mute": "Apklusināt",
  "report.mute_explanation": "Tu neredzēsi viņu ierakstus. Viņi joprojām var Tev sekot un redzēt Tavus ierakstus un nezinās, ka viņi ir apklusināti.",
  "report.next": "Tālāk",
  "report.placeholder": "Papildu komentāri",
  "report.reasons.dislike": "Man tas nepatīk",
  "report.reasons.dislike_description": "Tas ir kaut kas, ko tu nevēlies redzēt",
  "report.reasons.legal": "Tas ir nelikumīgi",
  "report.reasons.legal_description": "Tu uzskati, ka tas pārkāpj tavus vai servera valsts likumus",
  "report.reasons.other": "Tas ir kaut kas cits",
  "report.reasons.other_description": "Šī sūdzība neatbilst pārējām kategorijām",
  "report.reasons.spam": "Tā ir mēstule",
  "report.reasons.spam_description": "Ļaunprātīgas saites, viltus iesaistīšana vai atkārtotas atbildes",
  "report.reasons.violation": "Tas pārkāpj servera noteikumus",
  "report.reasons.violation_description": "Tu zini, ka tas pārkāpj īpašus noteikumus",
  "report.rules.subtitle": "Atlasi visus atbilstošos",
  "report.rules.title": "Kuri noteikumi tiek pārkāpti?",
  "report.statuses.subtitle": "Atlasi visus atbilstošos",
  "report.statuses.title": "Vai ir kādi ieraksti, kas apstiprina šo ziņojumu?",
  "report.submit": "Iesniegt",
  "report.target": "Ziņošana par: {target}",
  "report.thanks.take_action": "Šeit ir iespējas Mastodon redzamā satura pārvaldīšanai:",
  "report.thanks.take_action_actionable": "Kamēr mēs to izskatām, tu vari veikt darbības pret @{name}:",
  "report.thanks.title": "Nevēlies to redzēt?",
  "report.thanks.title_actionable": "Paldies, ka ziņoji, mēs to izskatīsim.",
  "report.unfollow": "Pārtraukt sekot @{name}",
  "report.unfollow_explanation": "Tu seko šim kontam. Lai vairs neredzētu tā ierakstus savā mājas plūsmā, pārtrauc sekot tam!",
  "report_notification.attached_statuses": "{count, plural, zero {Pievienoti {count} ierakstu} one {Pievienots {count} ieraksts} other {Pievienoti {count} ieraksti}}",
  "report_notification.categories.legal": "Tiesisks",
  "report_notification.categories.legal_sentence": "nelikumīgs saturs",
  "report_notification.categories.other": "Cita",
  "report_notification.categories.other_sentence": "cits",
  "report_notification.categories.spam": "Mēstule",
  "report_notification.categories.spam_sentence": "mēstule",
  "report_notification.categories.violation": "Noteikumu pārkāpums",
  "report_notification.categories.violation_sentence": "noteikumu pārkāpums",
  "report_notification.open": "Atvērt ziņojumu",
  "search.no_recent_searches": "Nav nesen veiktu meklējumu",
  "search.placeholder": "Meklēšana",
  "search.quick_action.account_search": "Profili atbilst {x}",
  "search.quick_action.go_to_account": "Doties uz profilu {x}",
  "search.quick_action.go_to_hashtag": "Doties uz tēmturi {x}",
  "search.quick_action.open_url": "Atvērt URL Mastodonā",
  "search.quick_action.status_search": "Ieraksti, kas atbilst {x}",
  "search.search_or_paste": "Meklēt vai ielīmēt URL",
  "search_popout.full_text_search_disabled_message": "Nav pieejams {domain}.",
  "search_popout.full_text_search_logged_out_message": "Pieejams tikai pēc pieteikšanās.",
  "search_popout.language_code": "ISO valodas kods",
  "search_popout.options": "Meklēšanas iespējas",
  "search_popout.quick_actions": "Ātrās darbības",
  "search_popout.recent": "Nesen meklētais",
  "search_popout.specific_date": "noteikts datums",
  "search_popout.user": "lietotājs",
  "search_results.accounts": "Profili",
  "search_results.all": "Visi",
  "search_results.hashtags": "Tēmturi",
  "search_results.see_all": "Skatīt visus",
  "search_results.statuses": "Ieraksti",
  "server_banner.about_active_users": "Cilvēki, kas izmantojuši šo serveri iepriekšējo 30 dienu laikā (darbīgie lietotāji mēnesī)",
  "server_banner.active_users": "darbīgi lietotāji",
  "server_banner.administered_by": "Pārvalda:",
  "server_banner.server_stats": "Servera statistika:",
  "sign_in_banner.create_account": "Izveidot kontu",
  "sign_in_banner.follow_anyone": "Seko ikvienam Fediversā un redzi visu pievienošanas secībā! Nekādu algoritmu, reklāmu vai klikšķēsmu.",
  "sign_in_banner.sign_in": "Pieteikties",
  "sign_in_banner.sso_redirect": "Piesakies vai Reģistrējies",
  "status.admin_account": "Atvērt @{name} satura pārraudzības saskarni",
  "status.admin_domain": "Atvērt {domain} satura pārraudzības saskarni",
  "status.admin_status": "Atvērt šo ziņu satura pārraudzības saskarnē",
  "status.all_disabled": "Pastiprināšana un citēšana ir atspējota",
  "status.block": "Liegt @{name}",
  "status.bookmark": "Grāmatzīme",
  "status.cancel_reblog_private": "Nepastiprināt",
  "status.cannot_reblog": "Šo ierakstu nevar pastiprināt",
  "status.continued_thread": "Turpināts pavediens",
  "status.copy": "Ievietot ieraksta saiti starpliktuvē",
  "status.delete": "Dzēst",
  "status.detailed_status": "Detalizēts sarunas skats",
  "status.direct": "Pieminēt @{name} privāti",
  "status.direct_indicator": "Pieminēts privāti",
  "status.edit": "Labot",
  "status.edited": "Pēdējoreiz labots {date}",
  "status.edited_x_times": "Labots {count, plural, zero {{count} reižu} one {{count} reizi} other {{count} reizes}}",
  "status.favourite": "Izlasē",
  "status.filter": "Atlasīt šo ierakstu",
  "status.history.created": "{name} izveidoja {date}",
  "status.history.edited": "{name} laboja {date}",
  "status.load_more": "Ielādēt vairāk",
  "status.media.open": "Jānoklikšķina, lai atvērtu",
  "status.media.show": "Noklikšķini, lai parādītu",
  "status.media_hidden": "Multivides ir paslēpts",
  "status.mention": "Pieminēt @{name}",
  "status.more": "Vairāk",
  "status.mute": "Apklusināt @{name}",
  "status.mute_conversation": "Apklusināt sarunu",
  "status.open": "Izvērst šo ierakstu",
  "status.pin": "Piespraust profilam",
  "status.quote_policy_change": "Kurš var citēt",
  "status.read_more": "Lasīt vairāk",
  "status.reblog": "Pastiprināt",
  "status.reblogged_by": "{name} pastiprināja",
  "status.reblogs.empty": "Neviens vēl nav pastiprinājis šo ierakstu. Kad kāds to izdarīs, šeit tiks parādīti lietotāji.",
  "status.redraft": "Dzēst un pārrakstīt",
  "status.remove_bookmark": "Noņemt grāmatzīmi",
  "status.remove_favourite": "Noņemt no izlases",
  "status.replied_to": "Atbildēja {name}",
  "status.reply": "Atbildēt",
  "status.replyAll": "Atbildēt uz tematu",
  "status.report": "Ziņot par @{name}",
  "status.sensitive_warning": "Jūtīgs saturs",
  "status.share": "Kopīgot",
  "status.show_less_all": "Rādīt mazāk visiem",
  "status.show_more_all": "Rādīt vairāk visiem",
  "status.show_original": "Rādīt pirmavotu",
  "status.title.with_attachments": "{user} pievienoja {attachmentCount, plural, zero {{attachmentCount} pielikumu} one {{attachmentCount} pielikumu} other {{attachmentCount} pielikumus}}",
  "status.translate": "Tulkot",
  "status.translated_from_with": "Tulkots no {lang} izmantojot {provider}",
  "status.uncached_media_warning": "Priekšskatījums nav pieejams",
  "status.unmute_conversation": "Noņemt sarunas apklusinājumu",
  "status.unpin": "Noņemt profila piespraudumu",
  "subscribed_languages.lead": "Pēc izmaiņu veikšanas Tavā mājas un sarakstu laika līnijā tiks rādīti tikai ieraksti atlasītajās valodās. Neatlasīt nevienu, lai saņemtu ierakstus visās valodās.",
  "subscribed_languages.save": "Saglabāt izmaiņas",
  "subscribed_languages.target": "Mainīt abonētās valodas priekš {target}",
  "tabs_bar.home": "Sākums",
  "tabs_bar.notifications": "Paziņojumi",
  "terms_of_service.effective_as_of": "Spēkā no {date}",
  "terms_of_service.title": "Pakalpojuma izmantošanas noteikumi",
  "time_remaining.days": "{number, plural, one {Atlikusi # diena} other {Atlikušas # dienas}}",
  "time_remaining.hours": "{number, plural, one {Atlikusi # stunda} other {Atlikušas # stundas}}",
  "time_remaining.minutes": "{number, plural, one {Atlikusi # minūte} other {Atlikušas # minūtes}}",
  "time_remaining.moments": "Atlikuši daži mirkļi",
  "time_remaining.seconds": "Atlikušas {number, plural, one {# sekunde} other {# sekundes}}",
  "trends.counter_by_accounts": "{count, plural, zero {{counter} cilvēku} one {{counter} cilvēks} other {{counter} cilvēki}} {days, plural, one {{day} dienā} other {{days} dienās}}",
  "trends.trending_now": "Pašlaik populāri",
  "ui.beforeunload": "Ja pametīsit Mastodonu, jūsu melnraksts tiks zaudēts.",
  "units.short.billion": "{count}Mjd",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}Tk",
  "upload_area.title": "Velc un nomet, lai augšupielādētu",
  "upload_button.label": "Pievienot bildi, video vai audio datni",
  "upload_error.limit": "Sasniegts datņu augšupielādes ierobežojums.",
  "upload_error.poll": "Datņu augšupielādes aptaujās nav atļautas.",
  "upload_form.edit": "Labot",
  "upload_progress.label": "Augšupielādē...",
  "upload_progress.processing": "Apstrādā…",
  "username.taken": "Šis lietotājvārds ir jau paņemts. Izmēģini citu",
  "video.close": "Aizvērt video",
  "video.download": "Lejupielādēt datni",
  "video.exit_fullscreen": "Iziet no pilnekrāna",
  "video.expand": "Paplašināt video",
  "video.fullscreen": "Pilnekrāns",
  "video.hide": "Slēpt video",
  "video.mute": "Izslēgt skaņu",
  "video.pause": "Pauze",
  "video.play": "Atskaņot",
  "video.skip_backward": "Tīt atpakaļ",
  "video.skip_forward": "Tīt uz priekšu",
  "video.unmute": "Ieslēgt skaņu",
  "video.volume_down": "Pagriezt klusāk",
  "video.volume_up": "Pagriezt skaļāk",
  "visibility_modal.button_title": "Iestatīt redzamību",
  "visibility_modal.header": "Redzamība un mijiedarbība",
  "visibility_modal.quote_followers": "Tikai sekotāji",
  "visibility_modal.quote_label": "Kurš var citēt",
  "visibility_modal.quote_nobody": "Tikai es",
  "visibility_modal.quote_public": "Ikviens",
  "visibility_modal.save": "Saglabāt"
}
